import { render, staticRenderFns } from "./statAppointXiangmuNvgong.vue?vue&type=template&id=4b956c26&scoped=true"
import script from "./statAppointXiangmuNvgong.vue?vue&type=script&lang=js"
export * from "./statAppointXiangmuNvgong.vue?vue&type=script&lang=js"
import style0 from "./statAppointXiangmuNvgong.vue?vue&type=style&index=0&id=4b956c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b956c26",
  null
  
)

export default component.exports